import React from "react";
import { Box, Typography } from "@mui/material";

export default function EmptyState({ icon, title, subtitle }) {
  return (
    <Box sx={{ py: 6, textAlign: "center", color: "text.secondary" }}>
      {icon && (
        <Box sx={{ fontSize: 56, mb: 1, opacity: 0.4, "& svg": { fontSize: 56 } }}>
          {icon}
        </Box>
      )}
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "text.primary" }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
